import { debounce } from "lodash";
import { registerScrollDetectEvent } from "./scroll-detect";
import { onLargeScreen } from "./breakpoint-detect";

declare const jQuery: any;
const $ = jQuery;

export function initHeaderLogoUrlOnScroll(): void
{
	const altSrc: string = window['iw'] && window['iw'].headerLogoUrlOnScroll;
	if (!altSrc)
	{
		return;
	}
	const $mainLogo = $(".main-header a.logo-link img");
	if ($mainLogo.length === 0)
	{
		return;
	}
	const scrollThreshold: number = (window["iw"].SCROLL_THRESHOLD === undefined) ? 90 : window["iw"].SCROLL_THRESHOLD;
	const origSrc: string = $mainLogo.attr("src");
	const mobileImageShouldOverride: boolean = $mainLogo.is("[data-mobile-src-done]");
	const setImgSrc = (src: string) => {
		if (!mobileImageShouldOverride || onLargeScreen())
		{
			$mainLogo.attr("src", src);
		}
	};
	const setImgSrcDefault = setImgSrc.bind(null, origSrc);
	const setImgSrcAlt = setImgSrc.bind(null, altSrc);
	registerScrollDetectEvent(setImgSrcAlt, setImgSrcDefault, () => scrollThreshold);
	const $window = $(window);
	$window.on("load resize", debounce(() => {
		$mainLogo.trigger(onLargeScreen() ? "disable-mobile-src" : "enable-mobile-src");
		if ($window.scrollTop() >= scrollThreshold)
		{
			setImgSrcAlt();
		}
	}, 50, { leading: true, trailing: true }));
}
